import axios from 'axios'
import { md5 } from './md5.js'
import router from '../router/index.js'

// 对象字母升序排序
const objSort = (obj) => {
  let newkey = Object.keys(obj).sort()
  let newObj = {}

  for (let i = 0; i < newkey.length; i++) {
    if (obj[newkey[i]] || obj[newkey[i]] === 0) {
      newObj[newkey[i]] = obj[newkey[i]]
    }
  }

  // 返回排好序的新对象
  return newObj
}
const request = axios.create({
  baseURL: '',
  headers: {
    'content-type': 'application/json;charset=UTF-8',
  },
})

request.interceptors.request.use(
  (config) => {
    let options = config

    options.data = options.data ? options.data : {}
    options.method = options.method ? options.method : 'post'

    // 请求时间戳
    options.data.timestamp = parseInt(new Date().getTime() / 1000)

    /* 接口签名计算开始 */
    // 系统 key 值
    // transferPage.vue 中的接口不需要 key
    if (!config.ignoreKey) {
      options.data.key = '74260f176fef3fe877351cf446c981c8'
    }
    // 参数名字母升序排序
    options.data = objSort(options.data)

    // 参数字符串拼接
    let formatData = {}
    let formatString = ''

    Object.keys(options.data).forEach(name => {
      if (typeof options.data[name] == 'object') {
        formatData[name] = JSON.stringify(options.data[name])
      } else {
        formatData[name] = options.data[name]
      }

      formatString += `${name}=${formatData[name]}&`
    })

    formatString = formatString.substring(0, formatString.length - 1)

    // //console.log(formatString, 'formatString')
    // md5转大写
    options.data.sign = md5(formatString).toUpperCase()
    delete options.data['key']

    /* 接口签名计算结束 */

    return options
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  function (result) {
    if (result.data.code == 102) {
      console.log('用户未登录', window.location)
      localStorage.removeItem("info")
      router.replace('login')
    }
    const { status } = result

    if (status >= 200 && status < 300) {
      let keywords = ['高活']
      let result_filter = JSON.stringify(result)
      keywords.forEach(x => {
        result_filter = result_filter.replace(new RegExp(x, 'g'), '')
      })
      // console.log('接口返回值Json字符串-----url',result.config.url);
      //   console.log('接口返回值Json字符串-----旧',result);
      //   console.log('接口返回值Json字符串-----新',result_filter);

      return Promise.resolve(JSON.parse(result_filter))
    } else {
      return Promise.reject(result)
    }
  },
  function (error) {
    // tips('服务器错误')
    return Promise.reject(error)
  }
)

export default request
